// import  ElLoading  from 'element-plus/lib/el-loading';

import { ElLoading } from 'element-plus'

let loadingCount = 0;       // 在途请求计数
let loadingInstance = null; // 当前 ElLoading 实例（null 表示未显示）
let showTimer = null;       // 延迟显示定时器
let hideTimer = null;       // 宽限关闭定时器
let shownAt = 0;            // 实际显示时刻，用于保证最短显示时长

// 三个可调时间（毫秒）
const SHOW_DELAY = 200;     // 请求超过该时长才显示 loading，快请求根本不闪
const HIDE_GRACE = 300;     // 计数归零后的宽限期，期间有新请求就不关，避免串行/嵌套请求“关一个又开一个”
const MIN_DURATION = 400;   // loading 一旦显示至少保持该时长，避免“刚显示就消失”的闪

const doStart = () => {
  loadingInstance = ElLoading.service({
    lock: true,
    text: '拼命加载中...',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)',
  });
  shownAt = Date.now();
};

const doClose = () => {
  if (loadingInstance) {
    loadingInstance.close();
    loadingInstance = null;
  }
};

// 计数归零、且过了宽限期后的真正收尾
const finishHide = () => {
  // 还没真正显示出来（快请求链）→ 取消待显示即可
  if (showTimer) {
    clearTimeout(showTimer);
    showTimer = null;
    return;
  }
  if (!loadingInstance) return;
  // 保证最短显示时长，避免刚显示就消失
  const elapsed = Date.now() - shownAt;
  if (elapsed >= MIN_DURATION) {
    doClose();
  } else {
    setTimeout(() => {
      if (loadingCount === 0) doClose();
    }, MIN_DURATION - elapsed);
  }
};

export const showLoading = () => {
  loadingCount += 1;
  // 有新请求进来：取消待关闭，保持 loading 连续
  if (hideTimer) {
    clearTimeout(hideTimer);
    hideTimer = null;
  }
  // 既没显示、也没在等待显示 → 启动延迟显示
  if (!loadingInstance && !showTimer) {
    showTimer = setTimeout(() => {
      showTimer = null;
      if (loadingCount > 0) doStart(); // 仍有在途请求才真正显示
    }, SHOW_DELAY);
  }
};

export const hideLoading = () => {
  if (loadingCount <= 0) return;
  loadingCount -= 1;
  if (loadingCount > 0) return; // 仍有在途请求，保持
  // 计数归零：进入宽限期；期间若有新请求(showLoading)会清掉此定时器
  if (hideTimer) clearTimeout(hideTimer);
  hideTimer = setTimeout(() => {
    hideTimer = null;
    if (loadingCount === 0) finishHide();
  }, HIDE_GRACE);
};
